import { useEffect, useMemo, useState } from 'react';
import { LineEditContext } from './LineEditContext';
import { ILineEditContextProvider } from './LineEditContext.types';

export const LineEditContextProvider = (props: ILineEditContextProvider) => {
    const [current, setCurrent] = useState(() => {
        // Try to get the stored value from sessionStorage
        const storedLineEditIndex = window.sessionStorage.getItem('lineEditIndex');
        return storedLineEditIndex ? parseInt(storedLineEditIndex, 10) : 0;
    });

    useEffect(() => {
        // Save the current value to sessionStorage whenever it changes
        window.sessionStorage.setItem('lineEditIndex', current.toString());
    }, [current]);

    const value = useMemo(() => {
        return { current, setCurrent };
    }, [current, setCurrent]);

    return <LineEditContext.Provider value={value}>{props.children}</LineEditContext.Provider>;
};

export default LineEditContextProvider;
